import React from 'react';

export const AddDataBoxImg = ({ handleClick, imgSrc, altText = "icon", className , height = '20px' , width = '20px'  }) => {
  return (
    <div className={className} onClick={handleClick} style={{ cursor: "pointer", display: "flex", alignItems: "center"}}>
      {imgSrc && <img src={imgSrc} alt={altText} height = {height} width = {width} />}
    </div>
  );
};

export const AddDataBox = ({ handleClick, type, className }) => {
  return (
    <div className={className} onClick={handleClick}>
      {type}
    </div>
  );
};

export const AddDataBoxButton = ({ handleClick, buttonText = "Create", className }) => {
  return (
    <div className={className} onClick={handleClick} style={{ cursor: "pointer", display: "flex", alignItems: "center", marginTop:'30px', marginLeft:'-30px' }}>
      <button 
        style={{ 
          padding: "4px 68px", 
          cursor: "pointer", 
          backgroundColor:'#BF1D2D', 
          textAlign:'center', 
          color:'#fff', 
          border:'none',
          borderRadius:'8px',
          marginLeft:'90px',
          marginTop:'-15px',
          fontSize:'14px'
        }}>
        {buttonText}
      </button>
    </div>
  );
};

export const AddDataBoxButtonShift = ({ handleClick, buttonText = "Create", className }) => {
  return (
    <div className={className} onClick={handleClick} style={{ cursor: "pointer", display: "flex", alignItems: "center", marginTop:'30px', marginLeft:'-30px' }}>
      <button 
        style={{ 
          padding: "4px 68px", 
          cursor: "pointer", 
          backgroundColor:'#BF1D2D', 
          textAlign:'center', 
          color:'#fff', 
          border:'none',
          borderRadius:'8px',
          marginLeft:'84px',
          marginTop:'-15px',
          fontSize:'14px'
        }}>
        {buttonText}
        <img src='/images/shift-icon.svg' width='14px' height= '14px' className='mx-1' />
      </button>
    </div>
  );
};
